import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useContext, useState } from "react";
import AwesomeIcon from "../AwesomeIcon";
import { faCheck, faPenToSquare, faXmark } from "@fortawesome/pro-regular-svg-icons";
import TextInput from "../FormComponents/TextInput";
import Toast from "../Toast";
import { useAddITPOCNumber, useAddQurePOCNumber } from "./services";
import { GatewayContext } from "./GatewayContext";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { mobNumberRegex } from "../../utils/regexValidation";
import classNames from "classnames";
function POC(_ref) {
  var _gatewayDetails$gatew, _gatewayDetails$gatew2, _qure_poc$phone, _qure_poc$phone2;
  var gatewayDetails = _ref.gatewayDetails,
    activeID = _ref.activeID,
    setActiveID = _ref.setActiveID,
    isFirstGateway = _ref.isFirstGateway,
    qure_poc = _ref.qure_poc,
    refetchQurePOC = _ref.refetchQurePOC;
  var _useContext = useContext(GatewayContext),
    refetchGatewayData = _useContext.refetchGatewayData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(""),
    ITNumber = _useState[0],
    setITNumber = _useState[1];
  var _useState2 = useState(""),
    qureNumber = _useState2[0],
    setQureNumber = _useState2[1];
  var _useState3 = useState(false),
    isQureFieldActive = _useState3[0],
    setIsQureFieldActive = _useState3[1];
  var addQurePOC = useAddQurePOCNumber();
  var addITPOC = useAddITPOCNumber();
  var handleITTeamNumber = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
      var _get;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return addITPOC.mutateAsync({
                phone: ITNumber,
                gateway_id: item === null || item === void 0 ? void 0 : item.uuid
              }).then(function () {
                refetchGatewayData();
                setITNumber("");
                setActiveID("");
              });
            case 3:
              _context.next = 10;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              setITNumber("");
              setActiveID("");
              Toast.error((_get = get(_context.t0, ["response", "data", "message"], "")) !== null && _get !== void 0 ? _get : t("rule.toast.saved_failed"));
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));
    return function handleITTeamNumber(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleQureTeamNumber = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _get2;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!isQureFieldActive) {
                _context2.next = 11;
                break;
              }
              _context2.prev = 1;
              _context2.next = 4;
              return addQurePOC.mutateAsync({
                phone: qureNumber
              }).then(function () {
                refetchQurePOC();
                setQureNumber("");
                setIsQureFieldActive(false);
              });
            case 4:
              _context2.next = 11;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              setQureNumber("");
              setIsQureFieldActive(false);
              Toast.error((_get2 = get(_context2.t0, ["response", "data", "message"], "")) !== null && _get2 !== void 0 ? _get2 : t("rule.toast.saved_failed"));
            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 6]]);
    }));
    return function handleQureTeamNumber() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "sm:!flex space-x-4 items-center !hidden"
  }, activeID === (gatewayDetails === null || gatewayDetails === void 0 ? void 0 : gatewayDetails.uuid) ? /*#__PURE__*/React.createElement("div", {
    className: "border rounded-md whitespace-nowrap border-teal-400 py-3 px-5 flex items-center text-gray-500 text-md space-x-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("p", null, "IT Team"), /*#__PURE__*/React.createElement(TextInput, {
    type: "text",
    name: "ITNumber",
    placeholder: "+000000000000",
    defaultValue: (_gatewayDetails$gatew = gatewayDetails === null || gatewayDetails === void 0 ? void 0 : gatewayDetails.gateway_poc_phone) !== null && _gatewayDetails$gatew !== void 0 ? _gatewayDetails$gatew : ITNumber,
    onChange: function onChange(val) {
      setITNumber(val);
    },
    maxLength: 15,
    wrapperClassName: "w-auto group !p-0",
    isClinicalField: true,
    className: "!bg-transparent border-none",
    inputClassName: "!text-left text-md bg-transparent text-gray-500 !border-gray-500",
    readOnly: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center space-x-2"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      handleITTeamNumber(gatewayDetails);
    },
    disabled: !mobNumberRegex(ITNumber),
    className: classNames("bg-teal-500 text-gray-200 p-2 rounded-sm", {
      "opacity-70 cursor-not-allowed": !mobNumberRegex(ITNumber)
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCheck
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setActiveID("");
    },
    className: "bg-gray-600 text-gray-200 p-2 rounded-sm"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center border-r border-gray-500 text-gray-500 space-x-2 pr-4"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setActiveID(gatewayDetails === null || gatewayDetails === void 0 ? void 0 : gatewayDetails.uuid);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    size: "sm",
    name: faPenToSquare,
    className: "hover:!text-teal-500 dark:hover:!text-teal-300 cursor-pointer group-hover:text-gray-600 dark:group-hover:text-gray-200"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-md"
  }, "IT team", " ", /*#__PURE__*/React.createElement("span", {
    className: "text-gray-800 dark:text-gray-100"
  }, (_gatewayDetails$gatew2 = gatewayDetails === null || gatewayDetails === void 0 ? void 0 : gatewayDetails.gateway_poc_phone) !== null && _gatewayDetails$gatew2 !== void 0 ? _gatewayDetails$gatew2 : /*#__PURE__*/React.createElement("span", {
    className: "text-gray-500"
  }, "(", t("add_contact"), ")")))), isQureFieldActive && isFirstGateway ? /*#__PURE__*/React.createElement("div", {
    className: "border rounded-md whitespace-nowrap border-teal-400 py-3 px-5 flex items-center text-gray-500 text-md space-x-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center space-x-1"
  }, /*#__PURE__*/React.createElement("p", null, "Qure.ai"), /*#__PURE__*/React.createElement(TextInput, {
    type: "text",
    name: "QureNumber",
    placeholder: "+000000000000",
    defaultValue: (_qure_poc$phone = qure_poc === null || qure_poc === void 0 ? void 0 : qure_poc.phone) !== null && _qure_poc$phone !== void 0 ? _qure_poc$phone : qureNumber,
    onChange: function onChange(val) {
      setQureNumber(val);
    },
    maxLength: 15,
    wrapperClassName: "w-auto group !p-0",
    isClinicalField: true,
    className: "!bg-transparent border-none",
    inputClassName: "!text-left text-md text-gray-500 bg-transparent !border-gray-500",
    readOnly: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center space-x-2"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      handleQureTeamNumber();
    },
    disabled: !mobNumberRegex(qureNumber),
    className: classNames("bg-teal-500 text-gray-200 p-2 rounded-sm", {
      "opacity-70 cursor-not-allowed": !mobNumberRegex(qureNumber)
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCheck
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setIsQureFieldActive(false);
    },
    className: "bg-gray-600 text-gray-200 p-2 rounded-sm"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-gray-500 space-x-2"
  }, isFirstGateway && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setIsQureFieldActive(true);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    size: "sm",
    name: faPenToSquare,
    className: "hover:!text-teal-500 dark:hover:!text-teal-300 cursor-pointer group-hover:text-gray-600 dark:group-hover:text-gray-200"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-md"
  }, "Qure.ai", " ", /*#__PURE__*/React.createElement("span", {
    className: "text-gray-800 dark:text-gray-100"
  }, (_qure_poc$phone2 = qure_poc === null || qure_poc === void 0 ? void 0 : qure_poc.phone) !== null && _qure_poc$phone2 !== void 0 ? _qure_poc$phone2 : /*#__PURE__*/React.createElement("span", {
    className: "text-gray-500"
  }, "(", t("add_contact"), ")")))));
}
export default POC;